import ShVxeTable from './src/main.vue'

ShVxeTable.install = Vue => {
  Vue.component(ShVxeTable.name, ShVxeTable)
}
export default ShVxeTable
